import { isEqual } from "lodash";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_DASHBOARD_SETTING_POPUP } from "../../../pages/external-dashboard/reducers/ea-dashboard-reducer";
import { FG_EXTERNAL_USER_TASK_EDITING, hasAnyFeatureGroupAccess } from "../../user-permissions-helper";
import ROISummaryPageTitleComponent from "../mdae-page-header/roi-summary-page-title/component";
const ExternalAuditPageTitle: React.FC<any> = () => {
  const title = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData?.title,
    isEqual
  );
  return (
    <div className="content" style={{ display: "flex" }}>
      {title}
    </div>
  );
};
const ExternalAuditHistoryPageTitle: React.FC<any> = () => {
  const title = useSelector(
    (state) => state["externalAuditReducer"].title,
    isEqual
  );
  return (
    <div className="content" style={{ display: "flex" }}>
      Audit History ({title})
    </div>
  );
};
const ExternalAuditDashboardPageTitle: React.FC<any> = () => {
  const dispatch = useDispatch();
  const onClickShow = () => {
    dispatch({
      type: TOGGLE_DASHBOARD_SETTING_POPUP,
      data: { isVisible: true },
    });
  };
  return (
    <>
      <div className="content" style={{ display: "flex" }}>
        Payer Audit Dashboard
      </div>
      <div>
        <span
          id="preferencesBtn"
          className="fa fa-cog"
          onClick={onClickShow}
          title="Dashboard Settings"
          aria-label="Dashboard Settings"
          role="button"
        ></span>
      </div>
    </>
  );
};
const ExternalUserMytasksPageTitle: React.FC<any> = () => {
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const isExternalUser = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser]
  );

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        marginRight: "60px",
        alignItems: "center",
      }}
    >
      <div className="content" style={{ flex: "1" }}>
        My Tasks
      </div>
      {isExternalUser && (
        <div>
          <a
            href="https://360.articulate.com/review/content/23c3ca78-8f60-48d5-9bd7-3604ab3424fe/review"
            target="_blank"
            style={{
              color: "white",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              className="help-circle-white hand-hover"
              style={{ height: 20, marginRight: 8 }}
            ></span>{" "}
            Show me how this works
          </a>
        </div>
      )}
    </div>
  );
};

interface INewExperiencePageTitle {
  title: string;
  redirectUrl: string;
}

const NewExperiencePageTitle: React.FC<INewExperiencePageTitle> = ({ title, redirectUrl }) => {
    const [checked, setChecked] = React.useState(true);
    return (
        <div style={{ display: "flex", width: "100%", marginRight: "60px", alignItems: "center" }}>
      <div className="content" style={{ flex: "1" }}>{title}</div>
            <div className="all-audits-toggle-wrapper">
                <span className="toggle-label">New Experience</span>
                <label className="toggle-switch" title="Toggle New Experience">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={e => {
                            setChecked(e.target.checked);
              if (!e.target.checked) window.location.href = redirectUrl;
                        }}
                    />
                    <span className="toggle-slider" />
                </label>
            </div>
        </div>
    );
};

const AuditQueuePageTitle: React.FC = () => <NewExperiencePageTitle title="Audit Queue" redirectUrl="/audit/auditlist?newExperience=false" />;

const RiskAreasNewPageTitle: React.FC = () => <NewExperiencePageTitle title="Risk Areas" redirectUrl="/analyzer/riskareas?newExperience=false" />;

const EMPortfolioPageTitle: React.FC = () => <NewExperiencePageTitle title="E&M Utilization" redirectUrl="/dashboards/embellcurve?newExperience=false" />;

const pageCustomTitleBarConfig = {
    "/audit/auditqueue": AuditQueuePageTitle,
    "/externalaudit/audit": ExternalAuditPageTitle,
    "/externalaudit/dashboard": ExternalAuditDashboardPageTitle,
    "/audit/mytasks": ExternalUserMytasksPageTitle,
    "/mdai/auditroi": ROISummaryPageTitleComponent,
    "/mdai/payerauditroi": ROISummaryPageTitleComponent,
    "/externalaudit/externalaudithistory": ExternalAuditHistoryPageTitle,
    "/analyzer/riskareasnew": RiskAreasNewPageTitle,
    "/dashboard/emportfolio": EMPortfolioPageTitle
};
export default pageCustomTitleBarConfig;
